import type { ModelId } from "@/lib/ai/models";

const MODEL_QUOTA_TOKEN_WEIGHTS: Partial<Record<ModelId, number>> = {
  "gpt-6-astra": 2,
};

/** Returns the multiplier applied to provider-reported tokens for quota usage. */
export function getModelQuotaTokenWeight(modelId: ModelId): number {
  return MODEL_QUOTA_TOKEN_WEIGHTS[modelId] ?? 1;
}
